import type { IntegrationConfig } from 'modules/Integrations/domain'
import quickBooksLogoSmall from './quickBooksLogoSmall.svg'
import { isProductionEnv } from 'lib/environment/environment'
import { QuickBooksIntegrationDetail } from './QuickBooksIntegrationDetail/QuickBooksIntegrationDetail'
import { quickBooksConfigurationLoader } from './quickBooks.loader'
import { quickBooksConfigurationMutator } from './quickBooks.mutator'
import { QuickBooksConfigurationManagement } from './QuickBooksConfigurationManagement/QuickBooksConfigurationManagement'
import type {
  Dashboardv99990101Api,
  Dashboardv99990101CommonModels
} from '@sequencehq/api/dashboard/v99990101'
import type { PaymentBankAccountsByCurrency } from 'Integrations/integrationsConfig/common/PaymentBankAccounts/paymentBankAccounts.types'

export const quickBooksIntegrationConfig: IntegrationConfig = {
  logoUrl: quickBooksLogoSmall,
  smallLogoUrl: quickBooksLogoSmall,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/quickbooks',
  features: {
    canDeleteLinks: true,
    canUninstall: true,
    isDocumentationOnly: false
  },
  title: 'QuickBooks',
  description: `Sync Sequence invoices in real-time and streamline your accounting process.`,
  components: {
    detail: QuickBooksIntegrationDetail,
    management: QuickBooksConfigurationManagement
  },
  communication: {
    connecting: {
      integrationAppParameters: {
        isSandbox: !isProductionEnv()
      }
    },
    configuration: {
      loader: quickBooksConfigurationLoader,
      mutator: quickBooksConfigurationMutator
    }
  }
}

export type QuickBooksTaxCodeMapping =
  Dashboardv99990101CommonModels.QuickbooksTaxCode.QuickbooksTaxCodeMapping

export type QuickBooksConfig = {
  /**
   * This is a value which does not exist on the API; it's effectively how we control
   * if an integration is 'paused' or not for now. It's expected that a way to more
   * directly configure this value will be exposed at some point!
   */
  importCustomerWorkflow: boolean
  taxExemptTaxCode: string
  taxableTaxCode: string
  reverseChargedTaxCode: string
  taxCodeMappings: Record<string, QuickBooksTaxCodeMapping>
  defaultAccount: string
  /** Push unlinked customers to QuickBooks when an invoice is finalised or sent. */
  autoLinkCustomers: boolean
  /** Resolved sync permission for the auto-link toggle (read-only, for the paused state). */
  autoLinkSyncPermission?: Dashboardv99990101Api.GetEntityTypeSyncToggles.SyncPermission
  /** The QuickBooks bank account payments in each currency are deposited to. */
  paymentBankAccounts: PaymentBankAccountsByCurrency
}
